/* eslint-disable eqeqeq */
/* eslint-disable react/jsx-pascal-case */
import React, { useEffect, useState } from "react";
import {
  Header,
  Footer,
  Link_Box1,
  Search_Box1,
} from "../../../components/index";
import { WebApi } from "../../../api/web";

const ConsultingList = () => {
  useEffect(() => {
    Consultinglist();
  }, []);
  const [consultingList, setConsultingList] = useState(null);
  const [valueSearch, setValueSearch] = useState("");

  const Consultinglist = async () => {
    await WebApi.consultingList()
      .then((res) => {
        setConsultingList(res.data.data.consultingList.consultings);
      })
      .catch((err) => {});
  };
  return (
    <>
      <Header title='لیست مشاوره های پرداخت شده' />
      <div className='container'>
        <div className='template-pages'>
          <Search_Box1
            placeholder='نام وکیل، شهر استان'
            setState={setValueSearch}
          />
          {consultingList &&
            consultingList
              .filter((data) => {
                return (
                  data.lawyer.fname.includes(valueSearch) ||
                  data.lawyer.lname.includes(valueSearch)
                );
              })
              .map((Data) => (
                <Link_Box1
                  name={`${Data.lawyer.fname} ${Data.lawyer.lname}`}
                  job='وکیل پایه یک دادگستری'
                  fileNumber='3394837592'
                  avatar={Data.lawyer.avatar}
                  link={`/callbackConsulting?id=${Data._id}`}
                />
              ))}
        </div>
      </div>
      <Footer />
    </>
  );
};
export default ConsultingList;
